/**
 * Keeps the sticky header docked just below the Essential Announcer promo
 * bar instead of overlapping it.
 *
 * The Essential Announcer app renders its own position:sticky bar as a
 * direct child of <body>, completely independent of this theme's sticky
 * header (see sections/header.liquid). Both were pinning themselves to
 * top: 0 with nothing coordinating them, which is what let the bar cover
 * part of the header while scrolling.
 *
 * This script measures the app bar's real rendered height - it can change
 * with viewport width, or when its message rotates - and writes it into
 * the --essential-bar-height CSS custom property. The matching CSS rule
 * in header.liquid uses that variable to offset the sticky header's `top`
 * instead of hard-coding it to 0.
 */
(function () {
  var root = document.documentElement;
  var currentBar = null;

  function setBarHeight(height) {
    root.style.setProperty('--essential-bar-height', Math.max(0, Math.round(height)) + 'px');
  }

  function measure(el) {
    setBarHeight(el ? el.getBoundingClientRect().height : 0);
  }

  var resizeObserver = null;
  if ('ResizeObserver' in window) {
    resizeObserver = new ResizeObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        measure(entries[i].target);
      }
    });
  }

  function findBar() {
    // Matches the Essential Announcer app's wrapper element. Scoped to a
    // class prefix (rather than the app's per-install unique id suffix)
    // so this keeps working if the app regenerates that id.
    return document.querySelector('[class*="essential_annoucement_bar_wrapper"]');
  }

  function attach(bar) {
    currentBar = bar;
    measure(bar);
    if (resizeObserver) {
      resizeObserver.observe(bar);
    } else {
      // Fallback for browsers without ResizeObserver: re-measure on resize.
      window.addEventListener('resize', handleWindowResize);
    }
  }

  function detach() {
    if (currentBar && resizeObserver) {
      resizeObserver.unobserve(currentBar);
    }
    if (!resizeObserver) {
      window.removeEventListener('resize', handleWindowResize);
    }
    currentBar = null;
    setBarHeight(0);
  }

  function handleWindowResize() {
    measure(currentBar);
  }

  function checkForBar() {
    var bar = findBar();
    if (bar && bar !== currentBar) {
      attach(bar);
    } else if (!bar && currentBar) {
      detach();
    }
  }

  checkForBar();

  // The app embed can render asynchronously after the page's initial
  // parse, so keep watching for it (and for it being dismissed/removed)
  // for a little while after load, then stop to avoid an open-ended
  // observer running on every DOM change for the life of the page.
  var bodyObserver = new MutationObserver(checkForBar);
  bodyObserver.observe(document.body, { childList: true, subtree: true });

  window.addEventListener('load', function () {
    setTimeout(function () {
      bodyObserver.disconnect();
    }, 5000);
  });
})();
